import React from 'react';
import { getContactTypeLabel, getContactTypeColor } from './utils';

const ContactCard = ({ contact, onRowClick }) => {
  return (
    <div 
      className="bg-white rounded-lg shadow-md p-4"
      onClick={() => onRowClick(contact.id)}
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-gray-900">{contact.company_name || `${contact.first_name} ${contact.last_name}`}</p>
          <p className="text-sm text-gray-500">{contact.email}</p>
        </div>
        <div className="text-right">
          <p className="text-sm text-gray-500">{contact.phone_number}</p>
          {contact.contact_type && (
            <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getContactTypeColor(contact.contact_type)}`}>
              {getContactTypeLabel(contact.contact_type)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
